import React, { useEffect, useState } from "react";

const PdfAutoDownload = () => {
  const [downloadStarted, setDownloadStarted] = useState(false);

  const pdfUrl =
    "https://res.cloudinary.com/bsgfcooa/image/upload/fl_attachment/v1776071038/AIF_Scheme_Kryzen_Biotech_9870424425_tnchwa.pdf";

  const redirectUrl = "https://kryzen.com/";

  const triggerDownload = () => {
    try {
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "AIF_Scheme.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setDownloadStarted(true);

      // Redirect after slight delay
      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    } catch (error) {
      console.error("Download failed:", error);
      setDownloadStarted(false);
    }
  };

  useEffect(() => {
    // Try auto download on page load
    triggerDownload();

    // Fallback: if not started in 2 sec, show button
    const timer = setTimeout(() => {
      if (!downloadStarted) {
        setDownloadStarted(false);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="page page-center">
      <div className="container container-tight py-4">
        <div className="text-center">
          <div className="mb-4">
            <h2 className="h3">Downloading your file...</h2>
            <p className="text-muted">
              If your download doesn't start automatically, click below.
            </p>
          </div>

          {!downloadStarted && (
            <button
              className="btn btn-primary"
              onClick={triggerDownload}
            >
              Download PDF
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PdfAutoDownload;